import { render } from "./EventSettings.vue?vue&type=template&id=bd7a60a6"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__